import { RootState } from '@reducers/index';
import { Flow } from '@customTypes/shared/Flow';

export const getFlow = (state: RootState): Flow => state.flowsReducer.flow;
export const getFlowsIsFetching = (state: RootState): boolean => state.flowsReducer.isFetching;
export const getFlowsFetchError = (state: RootState): string | null =>
    state.flowsReducer.fetchError;
